// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_BillingSettingsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_BillingSettingsResponse — billing configuration settings.
 * Used by GET /subscriptions/billing-settings and POST /subscriptions/billing-settings.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_BillingSettingsResponseDados {
billing_grace_days: number
}

export type Subscriptions_BillingSettingsResponse = ApiResponse<Subscriptions_BillingSettingsResponseDados>;

registerResponseContract('Subscriptions_BillingSettingsResponse', {
  billing_grace_days: { type: 'number',  required: true },
})
